import { atom } from "jotai";

export interface Timestamps {
  characters: string[];
  character_start_times_seconds: number[];
  character_end_times_seconds: number[];
}

export const currentPlayingAtom = atom({
  audio: "",
  title: "",
  cover: "",
  date: "",
  id: "",
  timestamps: {
    characters: [],
    character_start_times_seconds: [],
    character_end_times_seconds: [],
  } as Timestamps, // Add this new field
});

export const showPlayerAtom = atom(false);
export const isPausedAtom = atom(false);
export const currentTimeAtom = atom(0);
export const volumeAtom = atom(1);
